module.exports = __webpack_public_path__ + "img/contact-icon.bec85d86.png";